import { render } from "./FavoriteIcon2.vue?vue&type=template&id=38440883"
import script from "./FavoriteIcon2.vue?vue&type=script&lang=js"
export * from "./FavoriteIcon2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__